<template>
	<div class="wrapper">
		<div class="header"><BaseHeader :title="'商家服务订单'" /></div>
		<div class="content">
			<div class="recommend-box goods-box">
				<div class="goods-list">
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" style="width: 100%;">
						<div class="goods-item" v-for="item in goodsList" :key="item.id">
                            <div class="goods-img" @click="goDetail(item.id,item.shop_id)">
                                <img v-lazy="item.logo" alt="" />
                            </div>
                            <div class="goods-info">
                                <div class="goods-name">
                                    <span>{{item.shop_name}}</span>
                                </div>
								<div class="goods-name">
								    <span><a :href="'tel:' + item.shop_tel">{{item.shop_tel}}</a></span>
								</div>
                                <div class="goods-title">{{item.name}}</div>
                                <!-- <div class="goods-postage">
                                    <span style="border: 1px solid #9C6838;padding: 2px;border-radius: 5px;color: #9C6838">距离您{{item.dis_show}}</span>
                                </div> -->
                                <div class="goods-price">
                                    <p class="new-price" style="color: #C6241A;">
                                        ￥{{item.amount}}
                                    </p>
                                </div>
								<div class="goods-name">
								    <span>{{item.created_at}}</span>
								</div>
                            </div>
							<div class="goods-button">
								<!-- <div class="goods-btn" @click="handleGoLocation(item.lat,item.lng,item.shop_name,item.address)">
								    去这里
								</div> -->
								<div @click="goDetail(item.id,item.shop_id)" v-if="item.status == 0" class="goods-btn" style="background-color: #FF2200;margin-top: 10px;">
								    {{item.status_str}}
								</div>
								<div v-if="item.status == 1" class="goods-btn" style="background-color: #E56717;margin-top: 10px;">
								    {{item.status_str}}
								</div>
								<div @click="doUse(item.id)" v-if="item.status == 2" class="goods-btn" style="background-color: #00FF40;margin-top: 10px;">
								    {{item.status_str}}
								</div>
								<div v-if="item.status == 3" class="goods-btn" style="background-color: #2ECCFA;margin-top: 10px;">
								    {{item.status_str}}
								</div>
							</div>
                        </div>
					</van-list>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseHeader from '../../components/BaseHeader';
import { getNewShopGoodsOrder,saveNewShopGoodsOrder } from '../../service/goodsService';
import { Toast,Dialog } from 'vant';
import {wecharShare} from "../../util/weChat.js";
import { mapState, mapActions } from 'vuex';
import {isWeixinOrAlipayTools} from '../../util/tools';
import {getWxSharService} from '../../service/weChatService';

export default {
	name: 'shopgoodsorder',
	data() {
		return {
			goodsList: [],
			loading: false,
			finished: false,
			offset: {
				page: 0,
				limit: 10
			},
			cateid: null,
			searchKey: '', //搜索关键字
			active: 0, //搜索类别，0综合排序，1销量，2价格
			active1: 0,
			active2: 0,
			active3: 0,
			order: 0,
			myLocation:{
			    address:"",
			    latitude:0,
			    longitude:0,
			},
			shopId:null
		};
	},
	mounted() {
		this.isLogin();
		this.cateid = this.$route.params.cateid;
		//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
	},
	methods: {
		getData() {
			this.offset.page++;
			getNewShopGoodsOrder(this.userId,this.offset.page)
				.then(res => {
					if (res.status === 1) {
						this.loading = false;
						if (res.datas.length === 0) {
							this.finished = true;
							this.offset.page = 0;
							return;
						}
						this.goodsList = [...this.goodsList, ...res.datas];
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},

		goDetail(id,shopId) {
			this.$router.push({
				name: 'newshopgoodsorderdetail',
				params: {
					id: id
				}
			});
		},
		
		// 是否登录
		isLogin() {
			if (this.userId) {
				console.log('userId', this.userId);
			} else {
				this.$router.push({
					name: 'userLogin'
				});
				// Dialog.confirm({
				// 	title: '提示',
				// 	message: '您还未登录，是否前去登录'
				// })
				// 	.then(() => {
				// 		this.$router.push({
				// 			name: 'userLogin'
				// 		});
				// 	})
				// 	.catch(() => {});
			}
		},
		handleGoLocation(lat,lng,name,address) {
			const isWeixinOrAlipay = isWeixinOrAlipayTools();
			if(isWeixinOrAlipay === 'WeiXIN'){
				console.log('inweixin');
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
				    if (result.status === 1) {
				        wx.config({
				            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				            'appId': result.datas.appId, // 公众号名称，由商户传入
				            'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
				            'nonceStr': result.datas.nonceStr, // 随机串
				            'signature': result.datas.signature,// 微信签名
				            'jsApiList': ['openLocation'] // 必填，需要使用的JS接口列表
				        });
				        wx.ready(function () {
				            wx.openLocation({
				                latitude: parseFloat(lat),//目的地latitude
				                longitude: parseFloat(lng),//目的地longitude
				                name: name,
				                address: address,
				                scale: 15//地图缩放大小，可根据情况具体调整
				            });
				        });
				    } else {
				        Toast(result.msg);
				    }
				})
			}else{
				// 腾讯
				// var backurl = "http://www.shoudaole.cn/dist/#/nearbyShop";
				var url = "https://apis.map.qq.com/tools/routeplan/eword="+address+"&epointx="+lat+"&epointy="+lng+"&topbar=1?referer=收到乐&key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&back=0";
				/*百度*/
				// var url ="http://api.map.baidu.com/marker?location=34.271454,108.958486&title=百度导航&content="+address+"&output=html&src=yellowpage";
				// $("#mapBg .mapTab .mapBtn_b").attr("href",mapUrl_bd);
				window.location.href=url;
				return;
			}
		    // window.location.href = 'http://api.map.baidu.com/geocoder?address=' + address + '&output=html&src=webapp.baidu.openAPIdemo';
		},
		doUse(id){
			Dialog.confirm({
			  title: '提示',
			  message: '是否确认收货？',
			})
			  .then(() => {
				  saveNewShopGoodsOrder(id)
				  	.then(res => {
				  		if (res.status === 1) {
							this.goodsList = [];
							this.offset.page = 0;
				  			this.getData();
				  		} else {
				  			Toast(res.msg);
				  		}
				  	})
				  	.catch(err => {
				  		console.log(err);
				  	});
			  })
			  .catch(() => {
			    return false;
			  });
		}
	},
	components: {
		BaseHeader
	},
	computed: {
		...mapState({
			userId: state => state.userInfo.userId,
			openId: state => state.userInfo.openId
		})
	}
};
</script>

<style scoped lang="scss">
	.content{
		background-color: #F6F4F4;
		width: 100%;
	}
	.goods-box{
		display: flex;
		flex-direction: column;
	}
	.goods-list{
		display: flex;
		padding: 5px;
	}
	.goods-item{
		display: flex;
		margin: 5px;
		background-color: #fff;
		border-radius: 10px;
	}
	
	.goods-img{
		width: 30%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 10px;
	}
	
	.goods-img img{
		width: 80px;
		height: 80px;
		border-radius: 10px;
	}
	
	.goods-info{
		width: 50%;
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.goods-button{
		width: 20%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.goods-btn{
		background-color: #C6241A;
		color: #fff;
		font-weight: bold;
		width: 50px;
		height: 25px;
		line-height: 25px;
		border-radius: 10px;
		text-align: center;
	}
	
	.my-location{
	    background: #ffffff;
	    padding: 10px;
	    box-sizing: border-box;
	    span:nth-child(2){
	        margin-left: 10px;
	        color: #999999;
	    }
	}
</style>
